import { render, staticRenderFns } from "./GamePlayerDefeated.vue?vue&type=template&id=4045a2cd&scoped=true&"
import script from "./GamePlayerDefeated.vue?vue&type=script&lang=js&"
export * from "./GamePlayerDefeated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045a2cd",
  null
  
)

export default component.exports